import { render, staticRenderFns } from "./lstPrivilege.vue?vue&type=template&id=0fa0ae2e&"
import script from "./lstPrivilege.vue?vue&type=script&lang=js&"
export * from "./lstPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports